import React from 'react'

interface FormattedLargeNumberProps {
  value?: number
}

function FormattedLargeNumber({ value = 0 }: FormattedLargeNumberProps) {
  let formattedValue: number | string = value
  let suffix = ''

  if (value > 1000000) {
    formattedValue = Number(value / 1000).toFixed(1)
    suffix = 'M'
  } else if (value > 3000) {
    formattedValue = Number(value / 1000).toFixed(1)
    suffix = 'K'
  }

  return (
    <span>
      {formattedValue}
      {suffix}
    </span>
  )
}

export default FormattedLargeNumber

